import { environment } from '../../../environments/environment';

export const SEC_HEADERS_MAP = {
  'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
  'Content-Security-Policy': `frame-ancestors ${environment.apiHost}`,
  'X-Content-Type-Options': 'nosniff',
  'X-Xss-Protection': '1,mode=block',
};
